import { useContext } from 'react';

import { EventFormContext } from './event-form-context';

export const useExternalEventMenu = () =>
  useContext(EventFormContext).ExternalEventMenu;
